import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const analysisStatsApi = createApi({
  reducerPath: 'analysisStatsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/stats'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['AnalysisStats'],
  endpoints: (builder) => ({
    analysisStats: builder.mutation({
      query: (obj) => ({
        url: `analysis`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
  }),
});

export const { useAnalysisStatsMutation } = analysisStatsApi;
